<template>
  <Layout v-if="type === 'admin' && currentUserData.mainAdmin === 'yes'">
   
    <div>
      <div class="pb-2">
     <div>
      <h2 class="text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl sm:leading-10">
            Last Sermon ID : 
            <span style="color: #815433" class="text-red-600">  {{ incident.sermonID }} 
            </span>
          </h2>
      <BaseButton v-on:click="reset();">Reset Form</BaseButton>
    {{errorMessage}}
   
    <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b>Please Fill in all the Details:</b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div v-if="!mobileOpen">
   <!-- <div  class="pt-2">
        <label
          class="block uppercase tracking-wide text-gray-700 text-lg font-thin mb-2"
          >Pastor</label
        >
        <select
          class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
          v-model="entryOwner"
        >
          <option disabled value>...</option>
          <option value="B1 (FR3)">B1 (FR3)</option>
          <option value="B2 (CG)">B2 (CG)</option>
          <option value="B3 (LNJ/FR2)">B3 (LNJ/FR2)</option>
          <option value="B4 (LNS/FR1)">B4 (LNS/FR1)</option>
          <option value="C1 (Control Dayshift)">C1 (Control Dayshift)</option>
          <option value="C2 (Control Nightshift)">C2 (Control Nightshift)</option>
          <option value="C3 (Control Standby)">C3 (Control Standby)</option>
        </select>
      </div>-->
      <div  class="pt-2">
     <!-- <BaseSelect 
          label="Entry Type"
          :options="getClientTypes(CALL)"
          v-model="entryType"
        />-->
      </div>
      <BaseInput  label="Pastor Name" maxlength="40" placeholder="Pastro max 40..." v-model="Pastor" />
      <BaseInput label="Entry Date" type="date"  placeholder="..." v-model="entryDate" />
      <BaseInput label="Entry Time" type="time"  placeholder="..." v-model="entryTime" />
      <BaseInput  label="Sermon Name" maxlength="200" placeholder="Sermon Header max 200..." v-model="sermonName" />
       <BaseInput  label="Sermon Text" maxlength="200" placeholder="Sermon Text max 200..." v-model="text" />
        <BaseInput  label="Link" type="link" maxlength="2000" placeholder="Sermon ink..." v-model="document" />
      <br>
      <BaseButton v-on:click="checkForm(); addNumber(); createArray(); createArray1();  addIncident(); "  >Add Sermon</BaseButton>
    </div>
      <div v-if="mobileOpen" class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-sm leading-5 font-medium text-gray-500">
             Upload Document <p class="text-red-600"> (not required) </p>
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
            <BaseFileUploader :key="componentKey"
            label=""
            type="file"
            :uuid="true"
            path="documents"
            @uploaded="handleAdminDocument"
      />
            </dd>
         
          </div>
          <br>
    <div id="app" v-cloak>
    <div class="text-red-500 text-center text-xl pb-2">
    </div>
    <br>
  </div>
       </div>
    </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "./layouts/Main";
import BaseButton from "../components/BaseButton";
import ZA from "../data/za.json";
//import BaseSelect from "../components/BaseSelect";
import BaseInput from "../components/BaseInput";
import "vue-form-generator/dist/vfg.css";
import CALL from "../data/manuals.json";
import BaseFileUploader from "../components/BaseFileUploader2";

import {mapGetters } from "vuex";
//import Vue from "vue";

//const firebaseInstanceCopy = firebase.initializeApp(firebaseCredentials, "firebaseInstanceCopy");

export default {
  name: "addsermon",
  components: { Layout,  BaseButton, BaseInput, BaseFileUploader},
  data() {
    return {
      rules: [
				{ message:'One lowercase letter required.', regex:/[a-z]+/ },
				{ message:"One uppercase letter required.",  regex:/[A-Z]+/ },
				{ message:"8 characters minimum.", regex:/.{8,}/ },
				{ message:"One number required.", regex:/[0-9]+/ }
			],
			submitted:false,
      employer: {},
      user: "",
      array: "",
      imageDataURL: null,
      manualType: "",
      admins: [],
      errors: [],
      manualNo: "",
      incident: "",
      incidentNo: "",
      tab: "",
      document: "",
      manual: "",
      inc: "",
      man: "",
      //manualss: {},
      updatedBy : "",
      subject : "",
      description: "",
      resolution : "",
      //document: "",
      mobileOpen: false,
      entryOwner: "",
      sermonNo: "",
      entryType: "",
      entryDate:"",
      mobileOpen2: false,
      sermonName: "",
      text: "",
      Pastor: "",
      entryTime: "",
      summaryEntry: "",
      crossrefpeople: "",
      crossrefdealers: "",
      date : new Date(Date.now()).toLocaleDateString(),
      fileUrl: "",
      ZA,
      //TYPE,
     // KNOW,
      CALL,
      //KNOWLEDGE,
    };
  },
  computed: {
    ...mapGetters(["currentUserData"]),

    
  },
  watch: {
    location(location) {
      this.getEmployeeData(location);
    },
    manualID(manualID) {
      this.getManualID(manualID);
    },

  },
  created() {
      this.type = this.currentUserData.userType;
      this.userStatus = this.currentUserData.status;
      //this.getUserData();
      this.getIncidentNo();
     if (this.type !== "admin") {
        this.$router.push({
        name: "Home",
        });
      }
      //this.getAdminData();
   
  },
  mounted() {
  
  },
  methods: {
    addNumber() {
       this.sermonNo = this.incident.sermonID+=1;
     },
     handleAdminDocument1({ fileUrl }) {
      this.$db
        .collection("sermons")
        .doc(this.sermon.manualNo)
        .update({
          document: fileUrl,
        })
        
    },
    handleAdminDocument({ fileUrl }) {
      this.$db
        .collection("sermons")
        .doc(this.inc.id)
        .update({
          document: fileUrl,
        });
        this.redirect();
    },
    getIncidentID() {
      const userData = this.$db
        .collection("manuals")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("manualNo", "==",this.manual.manualID)
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.man = data;
        });
      });
    },
 
    getIncidentNo() {
      const userData = this.$db
        .collection("sermonID")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("active", "==",'yes')
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.incident = data;
        });
      });
    },
    getCurrentManual(){

    },
    reset () {
      
      this.entryDate= "",
      this.entryTime= "",
      this.Pastor = "",
      this.sermonName = "",
      this.text = "",
      this.errors = "",
      this.document = ""
      //this.manualType = "",
      //this.imageDataURL = ""
     
		},
    checkForm: function (e) {
      this.errors = [];

       
        if (!this.Pastor) {
          this.errors.push("Pastor is required...");
        }
        if (!this.entryDate) {
          this.errors.push("Date is required...");
        }
        if (!this.entryTime) {
          this.errors.push("Time is required...");
        }
        if (!this.sermonName) {
          this.errors.push("Sermon Name is required...");
        }
        if (!this.text) {
          this.errors.push("Sermon Text is required...");
        }
          if (!this.document) {
          this.errors.push("Sermon Link Text is required...");
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
    
    setTab(tab) {
      this.tab = tab;
    },   
    getClientTypes(calls) {
      return calls.map((call) => {
        return {
          value: `${call.admin}`,
          label: `${call.admin}`,
        };
      });
    },
    createArray(){
      if(!this.array)
      this.array = []

      for (let i = 0; i < this.entryType.length; i++){
      this.array.push(this.entryType.slice(0,i+1).toLowerCase());
      }
    },
    createArray1(){
      if(!this.array)
      this.array = []

      for (let i = 0; i < this.sermonName.length; i++){
      this.array.push(this.sermonName.slice(0,i+1).toLowerCase());
      }
    },
    addIncident() {
     
        this.$db.collection("sermons").add({
          
         
          entryDate: this.entryDate,
          entryTime: this.entryTime,
          sermonID : this.sermonNo,
          sermonName: this.sermonName,
          text: this.text,
          Pastor : this.Pastor,
          //crossrefdealers: this.crossrefdealers,
          timestamp: Date.now(),
          date: this.date,
          document : this.document,
          searchDate : this.entryDate,
          //document : "",
          addedBy: this.currentUserData.email,
          search: this.array,
        });

        window.confirm(
          "Sermon added successfully."
        );
        this.updateIncidentID();
        this.addSermonLink();
        //this.getIncidentID2();
        
        //this.toggleRequests();
      
    },
    addSermonLink() {
     
        this.$db.collection("sermonLinks").add({
          
          sermonID : this.sermonNo,
          document : this.document,
        
        });
        this.redirect();

      
    },
    getIncidentID2() {
      const userData = this.$db
        .collection("sermons")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("sermonID", "==",this.sermonNo)
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.inc = data;
        });
      });
    },
    redirect() {
      this.$router.push({
      name: "dashboard",
      });
    },
    updateManualID1(){
      this.$db.collection("manualID").add({
          manualID : this.manualNo,
        });
      
    }	,
    updateIncidentID(){
      this.$db
        .collection("sermonID")
        .doc(this.incident.id)
        .update({
          sermonID: this.sermonNo,
        })
        //.then(() => this.getPendingApprovals());
        //this.$router.push({
        //name: "dashboard",})
    },
    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
    },
      toggleMobilemenu2() {
      this.mobileOpen2 = !this.mobileOpen2;
    },
    getUserData() {
      const userData = this.$db
        .collection("users")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("idNumber", "==", this.currentUserData.idNumber)
        .where("email", "==", this.currentUserData.email)
        .where("contactNumber", "==", this.currentUserData.contactNumber);

      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.user = data;
        });
      });
    },
  },
};
</script>

<style scoped>

.hints {
	max-width:400px;
	padding:1em;
	background:whitesmoke;
	margin: 1em 0;
	font-size: .9em;
	color:darken(#D4DEDF, 50%);

}
.visibility {
	all:unset;
	background:whitesmoke;
	display:inline-block;
	vertical-align:center
}
.password {
	display:flex;
	align-items:center;
}
</style>
